// Frontend/src/api/auth.ts
import api, { setAccessToken, clearAccessToken } from "./client";

export type Role = "SUPER_ADMIN" | "HOA_ADMIN" | "RESIDENT";

export type Me = {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: Role;
  building_id: string | null;
  is_staff: boolean;
  is_superuser: boolean;
};

export type LoginResponse = {
  access: string;
  user: Me;
};

export async function login(email: string, password: string): Promise<LoginResponse> {
  const res = await api.post<LoginResponse>("/auth/login/", { email, password });
  const data = res.data;
  if (!data?.access) {
    throw new Error("Invalid login response: missing access token");
  }
  setAccessToken(data.access);
  return data;
}

export async function fetchMe(): Promise<Me> {
  const res = await api.get<Me>("/auth/me/");
  return res.data;
}

export async function logout(): Promise<void> {
  try {
    // Call backend FIRST while token is still valid
    // This allows the server to properly identify and clear the refresh cookie
    await api.delete("/auth/me/");
  } catch (error) {
    // Ignore network errors on logout, but log for debugging
    console.warn('Backend logout failed:', error);
  } finally {
    // ALWAYS clear token, even if backend call fails
    clearAccessToken();
  }
}
